<template>
    <div
        class="flex flex-col p-4 space-y-6 bg-white shadow-lg sm:flex-row sm:space-x-6 sm:space-y-0 rounded-2xl"
    >
        <div class="sm:w-1/2">
            <img
                :src="vehicle.image"
                class="object-cover rounded-2xl h-60 sm:h-96"
                :alt="vehicle.name"
            />
        </div>

        <div class="flex flex-col justify-between pb-6 sm:w-1/2 sm:pb-0">
            <div
                class="mb-8 text-3xl font-bold text-center text-primary-text sm:text-left"
            >
                {{ vehicle.name }}
            </div>

            <div>
                <div class="flex items-center mb-4">
                    <TransmissionIcon class="mr-3 text-gray-600 h-7 w-7" />

                    <div class="text-lg text-gray-600">
                        {{ vehicle.gearbox }}
                    </div>
                </div>

                <div class="flex items-center mb-4">
                    <CarSeatIcon class="mr-3 text-gray-600 h-7 w-7" />

                    <div class="text-lg text-gray-600">
                        {{ vehicle.seats }} Sitze
                    </div>
                </div>

                <div class="flex items-center mb-4">
                    <TouristBagIcon class="mr-3 text-gray-600 h-7 w-7" />

                    <div class="text-lg text-gray-600">
                        {{ vehicle.baggage }} Gepäckstücke
                    </div>
                </div>

                <div class="flex items-center mb-4">
                    <CheckIcon class="mr-3 text-gray-600 h-7 w-7" />

                    <div class="text-lg text-gray-600">
                        {{ booking.km }} Kilometer inklusive
                    </div>
                </div>

                <div class="flex items-center">
                    <PlusCircleIcon class="mr-3 text-gray-600 h-7 w-7" />

                    <div class="flex items-center space-x-3 text-gray-600">
                        <div class="relative rounded-md shadow-sm">
                            <select
                                name="additional_km"
                                id="additional_km"
                                v-model="additionalKilometers"
                                class="block w-full pr-10 rounded-md border-primary border-opacity-30"
                            >
                                <option value="0">0</option>
                                <option value="100">100</option>
                                <option value="200">200</option>
                                <option value="300">300</option>
                                <option value="400">400</option>
                                <option value="500">500</option>
                            </select>
                        </div>

                        <div class="text-lg">Zusatzkilometer</div>
                    </div>
                </div>
            </div>

            <div class="mt-10">
                <div
                    class="flex flex-col items-center justify-between space-y-5 sm:flex-row sm:space-y-0"
                >
                    <div>
                        <div
                            class="text-3xl font-extrabold text-center text-primary sm:text-left"
                        >
                            {{ vehicle.price[additionalKilometers] }} €
                        </div>
                        <small class="font-light text-gray-500">
                            für den ausgewählten Zeitraum
                        </small>
                    </div>

                    <div>
                        <StyledButton background-primary>
                            <Link
                                as="button"
                                :href="route('checkout.step.vehicles.store')"
                                method="post"
                                :data="{
                                    vehicle_id: vehicle.id,
                                    additional_km: additionalKilometers,
                                }"
                            >
                                <div class="flex items-center">
                                    Fahrzeug auswählen
                                    <ArrowRightIcon class="w-5 h-5 ml-2" />
                                </div>
                            </Link>
                        </StyledButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    CheckIcon,
    PlusCircleIcon,
    ArrowRightIcon,
} from "@heroicons/vue/outline";
import TransmissionIcon from "@/Components/Icons/TransmissionIcon.vue";
import TouristBagIcon from "@/Components/Icons/TouristBagIcon.vue";
import CarSeatIcon from "@/Components/Icons/CarSeatIcon.vue";
import StyledButton from "@/Components/StyledButton.vue";
import { Link } from "@inertiajs/inertia-vue3";

export default {
    components: {
        CheckIcon,
        PlusCircleIcon,
        TransmissionIcon,
        TouristBagIcon,
        CarSeatIcon,
        StyledButton,
        ArrowRightIcon,
        Link,
    },

    props: {
        vehicle: {
            type: Object,
            required: true,
        },
        booking: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            additionalKilometers: 0,
        };
    },
};
</script>
